import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Approbation } from '../../models/approbation.model';

@Component({
    selector: 'app-approbations-edition',
    templateUrl: './approbations-edition.component.html',
    styleUrls: ['./approbations-edition.component.scss']
})
export class ApprobationsEditionComponent implements OnInit {

    @Input() approbations        : Approbation[];
    @Input() selectedApprobations: Approbation[];

    @Output() selectedApprobationsChange: EventEmitter<Approbation[]> = new EventEmitter<Approbation[]>();

    public labels: any = {

        emptyApprobationsMessage: 'No hay autorizaciones para esta edición'

    }

    public approbationTypes     : string[];
    public approbationsWithCheck: { approbation: Approbation, checked: boolean }[];

    ngOnInit (): void {

        this.approbationTypes = [... new Set(this.approbations.map(a => a.approbationType.type))];

        this.approbationsWithCheck = [];
        this.approbations.forEach(approbation => {

            let selectedItem = {
                approbation: approbation,
                checked : this.selectedApprobations?.findIndex(sa => sa.approbationId === approbation.approbationId) > -1
            }

            this.approbationsWithCheck.push(selectedItem);

        });

    }

    public getApprobationsByType(approbationType: string) {

        return this.approbationsWithCheck.filter(item => item.approbation.approbationType.type === approbationType);

    }

    public onCheckedApprobationChange(event: any, selectedItem: any) {

        let approbationCheckIndex = this.approbationsWithCheck.findIndex(sa => selectedItem.approbation.approbationId === sa.approbation.approbationId);
        if (approbationCheckIndex > -1) {
            this.approbationsWithCheck[approbationCheckIndex].checked = event.checked;
        }

        let allRequiredApprobationsChecked = this.approbationsWithCheck
            .filter(item => item.approbation.isRequired)
            .every(item => item.checked);

        if (allRequiredApprobationsChecked) {
            this.selectedApprobations = this.approbationsWithCheck.filter(sa => sa.checked).map(sa => sa.approbation);
            this.selectedApprobationsChange.emit(this.selectedApprobations);
        }

    }

}
